import { render, staticRenderFns } from "./pre_base_2.vue?vue&type=template&id=70964ad0&scoped=true"
import script from "./pre_base_2.vue?vue&type=script&lang=js"
export * from "./pre_base_2.vue?vue&type=script&lang=js"
import style0 from "./pre_base_2.vue?vue&type=style&index=0&id=70964ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70964ad0",
  null
  
)

export default component.exports